/**
 * created 29.09.2025
 */
import type {PropsWithChildren} from 'react';
import React from 'react';
import BottomNav from "../BottomNav/BottomNav";
import './DesktopTopNav.css';
import StreakElement from "../StreakElement/StreakElement";

type DesktopTopNavComponentType = PropsWithChildren<{}>

export function DesktopTopNav(props: DesktopTopNavComponentType) {
  return <div className="product-header-desktop">
    <div className="product-header-desktop-menu">
      <img src="/images/logo-full.png" alt="aiCourses" className="product-header-logo-desktop" />
      <div className="menu-desktop-container"><BottomNav/></div>
      <div className="streak-element-container">
        <div className="streak-element"><StreakElement /></div>
      </div>
    </div>
  </div>
}
